import NODES from './nodes'
import EDGES from './edges'
import GRAPH from './graph'
import BOOKMARKS from './bookmarks'
import ME from './me'
import USERS from './users'
import AUTH from './auth'
import ERRORS from './errors'
import PENDING from './pending'
import CONFIRM from './confirm'
import PERMISSIONS from './permissions'
import CONNECTION from './connection'
import PROMPT from './prompt'
import CONTENT_GENERATION from './contentGeneration'
import GRAPH_QUERY from './graphQuery'
import KINDS from './kinds'
import SHAPES from './shapes'


export default {
  NODES,
  EDGES,
  KINDS,
  SHAPES,
  BOOKMARKS,
  ME,
  USERS,
  AUTH,
  GRAPH,
  ERRORS,
  PENDING,
  CONFIRM,
  PERMISSIONS,
  CONNECTION,
  PROMPT,
  CONTENT_GENERATION,
  GRAPH_QUERY,
  RESET: 'RESET_STORE'
}
